export enum TagStatus {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
